import { createSelector } from "reselect";

import { RootState } from "app/store/rootReducer";

export const stateSelector = (state: RootState) => state.ksList;
export const ksListsSelector = createSelector(stateSelector, (state) => state.ksLists);
export const ksSublistSelector = createSelector(stateSelector, (state) => state.ksSublists);
export const ksListInvalidateKeySelector = createSelector(stateSelector, (state) => state.invalidateKey);
export const ksListDetailedKs2Selector = createSelector(stateSelector, (state) => state.detailedKs2);
